<template>
  <div class="w-ful h-full">
    <div class="container">
      <Transition name="fade" mode="out-in">
        <div
          class="max-w-[988px] mx-auto rounded-xl overflow-hidden bg-white"
          :key="loading"
        >
          <template v-if="loading">
            <ShimmerLoaderSingle />
          </template>
          <template v-else>
            <div class="relative">
              <img
                :src="
                  single?.cover?.length ? single?.cover : '/images/empty.png'
                "
                class="object-cover w-full h-full !max-h-[450px] z-0"
                alt=""
              />
              <div
                class="absolute z-10 top-0 cover-linear w-full h-full flex flex-col items-start justify-end p-6"
              >
                <div class="mb-2 sm:mb-4 flex items-center gap-4">
                  <p class="flex-y-center">
                    <span class="icon-calendar text-green mr-1" />
                    <span class="text-sm text-white mt-0.5">
                      {{
                        dayjs(single.created_at)
                          .locale("en")
                          .format("DD MMMM, HH:mm")
                      }}
                    </span>
                  </p>
                  <p class="flex-y-center">
                    <span class="icon-eye text-green mr-1" />
                    <span class="text-sm text-white mt-0.5">{{
                      single?.view_count
                    }}</span>
                  </p>
                </div>
                <h2
                  class="text-white text-xl sm:text-2xl md:text-[32px] font-bold leading-136 line-clamp-2"
                >
                  {{ single.title }}
                </h2>
              </div>
            </div>
            <div class="gap-8 p-6">
              <main class="col-span-12 md:col-span-9">
                <div
                  v-html="single?.content"
                  class="single-content w-full"
                ></div>
              </main>
            </div>
          </template>
        </div>
      </Transition>
    </div>
  </div>
</template>
<script setup lang="ts">
import ShimmerLoaderSingle from "@/modules/Landing/components/Shimmer/LoaderSingle.vue";
import dayjs from "dayjs";

interface Props {
  single: {
    id: number;
    title: string;
    slug: string;
    content: string;
    cover: string;
    status: string;
    view_count: number;
  };
  loading: boolean;
}
const props = defineProps<Props>();
</script>
<style>
.single-content div {
  max-width: 698px;
  margin: 0 auto;
}
.single-content figure {
  margin: 24px auto 40px;
  width: 100%;
  max-height: 498px;
  height: 100%;
}
.single-content figure img {
  width: 100%;
  height: 100%;
  max-height: 498px;
  object-fit: cover;
  border-radius: 4px;
}
.single-content p img {
  width: 100%;
  height: 100%;
  max-height: 498px;
  object-fit: cover;
  border-radius: 4px;
}
.single-content figure figcaption {
  margin-top: 8px;
  color: #919299;
  font-size: 12px;
  font-style: italic;
  line-height: 140%;
}
.single-content * {
  font-family: "Open Sans", sans-serif !important;
}
.single-content > p {
  color: #191f2e;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  margin-bottom: 16px;
}
.single-content iframe {
  display: flex;
  max-width: 550px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  position: static;
  visibility: visible;
  height: 452px;
  flex-grow: 1;
}
.single-content blockquote {
  max-width: 698px;
  margin: 24px auto;
  border-radius: 4px;
  background: rgba(162, 188, 222, 0.2);
  padding: 24px;
  color: #2c3752;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  position: relative;
}
.dark .single-content blockquote {
  color: white;
}
.single-content blockquote::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #52618f;
  border-radius: 4px;
}
.single-content blockquote:after {
  content: "";
  position: absolute;
  top: 24px;
  left: 24px;
  margin: 0;
}
.single-content a {
  color: #189fff;
}
.single-content a:hover {
  text-decoration: underline;
}
.cover-linear {
  background: linear-gradient(
    180deg,
    rgba(22, 28, 45, 0) 0%,
    rgba(22, 28, 45, 0.06) 7.29%,
    rgba(22, 28, 45, 0.88) 100%
  );
}
</style>
